// @ts-nocheck
import {
  SPELLS,
} from "../../data";
import {
  TAU,
  clamp,
} from "../../util";
import { Game } from "../game-base";

Game.VR_CLOSE_DUR = 0.42;
Game.VR_CORE_FRAC = 0.42;

Game.prototype.voidRipDrawFrac = function (sg) {
  const armDelay = (SPELLS.voidrip && SPELLS.voidrip.armDelay) || 0.55;
  if (sg.arm > 0) return clamp(1 - sg.arm / armDelay, 0, 1);
  if (sg.life != null && sg.life < Game.VR_CLOSE_DUR) {
    return clamp(sg.life / Game.VR_CLOSE_DUR, 0, 1);
  }
  return 1;
};

Game.prototype.voidRipFade = function (sg) {
  const df = this.voidRipDrawFrac(sg);
  if (sg.arm > 0) return 0.55 + 0.45 * df;
  if (sg.life != null && sg.life < Game.VR_CLOSE_DUR) return df;
  return 1;
};

Game.prototype.drawVoidRipHorizon = function (c, sg, t, r, open, fade) {
  const pulse = 0.5 + 0.5 * Math.sin(t * 4.5 + (sg.pulse || 0));
  const coreR = r * Game.VR_CORE_FRAC * open;
  if (coreR < 4) return;

  c.save();
  c.translate(sg.x, sg.y);
  c.rotate(t * 0.35 + (sg.pulse || 0) * 0.1);

  c.globalCompositeOperation = "lighter";
  c.globalAlpha = fade * open * (0.28 + 0.18 * pulse);
  const rim = c.createRadialGradient(0, 0, coreR * 0.78, 0, 0, coreR * 1.14);
  rim.addColorStop(0, "rgba(90,60,140,0)");
  rim.addColorStop(0.45, "rgba(110,80,170,0.55)");
  rim.addColorStop(0.72, "rgba(40,24,60,0.35)");
  rim.addColorStop(1, "rgba(0,0,0,0)");
  c.fillStyle = rim;
  c.beginPath();
  c.arc(0, 0, coreR * 1.14, 0, TAU);
  c.fill();

  c.globalAlpha = fade * open * 0.22;
  c.strokeStyle = "rgba(70,48,100,0.7)";
  c.lineWidth = 2;
  c.beginPath();
  c.arc(0, 0, coreR * 1.02, 0, TAU);
  c.stroke();

  c.restore();
  c.globalAlpha = 1;
  c.globalCompositeOperation = "source-over";
};

Game.prototype.drawVoidRip = function (c, sg, t) {
  const r = sg.r || 88;
  const drawFrac = this.voidRipDrawFrac(sg);
  const fade = this.voidRipFade(sg);
  if (drawFrac < 0.02) return;

  const open = drawFrac;
  const coreR = r * Game.VR_CORE_FRAC * open * 0.94;
  const outerR = r * open * 1.04;

  this.drawArenaTwistField(c, {
    cx: sg.x, cy: sg.y, coreR, outerR, open, fade, t,
    pulse: sg.pulse || 0, armed: sg.arm <= 0,
  });

  const voidObj = { x: sg.x, y: sg.y, r, fillStars: sg.fillStars };
  this.drawVoidFieldCore(c, voidObj, fade, t, drawFrac, Game.VR_CORE_FRAC);
  sg.fillStars = voidObj.fillStars;

  this.drawVoidRipHorizon(c, sg, t, r, open, fade);
};
